import { ParsedUrlQuery } from 'querystring';
import { GetStaticProps, GetStaticPaths } from 'next/types';
import {
  Product,
  GetProductDocument,
  GetProductQuery,
  GetAllProductSlugsDocument,
  GetAllProductSlugsQuery,
  initializeApollo,
  ssrFetchAll,
} from '@axis/graphql';

import ProductPage, { getStaticProps as getStaticShopProps } from '.';

type ContextParams = ParsedUrlQuery & { slug: string };
type StaticProps = { props: { [key:string]: unknown } }
export const getStaticProps: GetStaticProps = async (context) => {
  const results: unknown = await getStaticShopProps(context);

  const apolloClient = initializeApollo();
  const { slug } = context.params as ContextParams;

  const { data } = await apolloClient.query<GetProductQuery>({
    query: GetProductDocument,
    variables: { slug },
  });

  const { product } = data;

  return { props: { product, ...(results as StaticProps).props } };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const apolloClient = initializeApollo();

  const products = await ssrFetchAll<GetAllProductSlugsQuery, Product>(
    apolloClient,
    GetAllProductSlugsDocument,
    'products',
    200,
  );

  const paths: { params: ContextParams }[] = products.map(
    (product: Product) => ({ params: { slug: product.slug as string } }),
  );

  return { paths, fallback: 'blocking' };
};

export default ProductPage;
